<template>
  <div id="app">
    <v-app id="inspire">
      <v-content>
        <v-container fluid fill-height>
          <v-layout row align-center justify-center>
            <v-flex xs12 sm8 md4>
              <v-card class="elevation-12">
                <v-card-title>
                  <v-flex align-start>
                    <v-subheader class="login-font display-2 blue--text">
                      Login
                      <span class="login-subheading-font">DISC Test</span>
                    </v-subheader>
                  </v-flex>

                  <v-flex align-end></v-flex>
                </v-card-title>
                <v-card-text>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-text-field
                      v-model="username"
                      :rules="usernameRules"
                      prepend-icon="email"
                      name="login"
                      label="Email"
                      required
                      type="text"
                    ></v-text-field>
                    <v-text-field
                      v-model="password"
                      :rules="passRules"
                      prepend-icon="lock"
                      name="password"
                      required
                      label="Password"
                      id="password"
                      :append-icon="
                        showPassword ? 'visibility' : 'visibility_off'
                      "
                      :type="showPassword ? 'text' : 'password'"
                      counter
                      @click:append="showPassword = !showPassword"
                      @keypress.enter="submit"
                    ></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    v-tooltip.top-center="{ content: 'hris link' }"
                    slot="activator"
                    depressed
                    round
                    color="secondary"
                    dark
                    href="http://hris.indomaretgroup.com"
                    target="_blank"
                  >
                    <v-icon>link</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    :loading="loading"
                    depressed
                    round
                    color="secondary"
                    :disabled="!valid || loading"
                    @click="submit"
                  >
                    Login
                    <span slot="loader" class="custom-loader">
                      <v-icon light>cached</v-icon>
                    </span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<style>
.login-font {
  letter-spacing: 0.05em !important;
  padding-top: 20px !important;
}
.login-subheading-font {
  font-size: 10px;
  padding-top: 22px;
  padding-left: 5px;
  font-style: italic !important;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



<script>
import { mapMutations } from 'vuex';
export default {
  name: 'c-login',

  data() {
    return {
      // drawer: null,
      // user : {},
      loading: false,
      loader: null,
      valid: true,
      username: '',
      usernameRules: [(v) => !!v || 'Email harus di isi!'],

      password: '',
      passRules: [
        (v) => !!v || 'Password tidak boleh kosong',
        (v) => (v && v.length >= 5) || 'Minimal 5 karakter',
      ],

      showPassword: false,
    };
  },
  props: {
    source: 'http://hris.indomaretgroup.com',
  },

  methods: {
    ...mapMutations('app', ['setAuth', 'setAlert']),

    submit() {
      if (this.$refs.form.validate()) {
        this.loader = 'loading';
        const l = this.loader;
        this[l] = !this[l];

        let formData = {
          username: this.username,
          password: this.password,
        };

        this.$store
          .dispatch('login', formData)
          .then((response) => {
            this.$router.push('/dashboard');
            Bus.$emit('login', response);
            this.setAlert({
              status: true,
              text: 'Login Berhasil',
              type: 'success',
            });
          })
          .catch((error) => {
            this.setAlert({
              status: true,
              text: error.response.data,
              type: 'error',
            });

            this[l] = false;
            this.loader = null;
          });
      }
    },
  },
};
</script>